import { FieldPath } from "react-hook-form";
import { continents } from "../../../../services/centralStore";
export type SearchOptionsType = {
    [key in FieldPath<SearchFormInputs>]: (string | number)[];
};
export const SearchOptions: Partial<SearchOptionsType> = {
    focus: ["beach", "city", "nature"] as const,
    month: [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        "spring",
        "summer",
        "autumn",
        "winter"
    ] as const,
    continent: continents,
    "other.visaOrigin": ["eu", "usa"] as const,
    "prices.flightOrigin": [
        "europe",
        "canada",
        "asia",
        "easternUs",
        "centralUs",
        "westernUs"
    ] as const,
    suitability: [
        "couples",
        "groupOfFriends",
        "solo",
        "smallChildren",
        "schoolAgeChildren",
        "young",
        "midAge",
        "seniors",
        "partySeekers",
        "honeymooners"
    ] as const
};
